module.exports = __webpack_public_path__ + "img/wb_code.6fa7e54a.png";